import { BATCH_IMAGES_CHUNK_SIZE } from '@/lib/constants/batches';

export function getBatchSegmentKey(
  currentBatch: number | null | undefined,
  totalBatches: number | null | undefined,
  totalImages: number | null | undefined,
): string | null {
  if (
    currentBatch == null ||
    totalImages == null ||
    totalImages <= 0 ||
    !Number.isFinite(currentBatch) ||
    !Number.isFinite(totalImages)
  ) {
    return null;
  }
  const cap = Math.max(1, Math.trunc(totalBatches ?? 0));
  const c = Math.min(Math.max(Math.trunc(currentBatch), 1), cap);
  return `${c}:${cap}`;
}

export function getProgressRangeForBatches(
  currentBatch: number | null | undefined,
  totalBatches: number | null | undefined,
  totalImages: number | null | undefined,
): { low: number; high: number } | null {
  if (
    currentBatch == null ||
    totalImages == null ||
    totalImages <= 0 ||
    !Number.isFinite(currentBatch) ||
    !Number.isFinite(totalImages)
  ) {
    return null;
  }

  const chunk = BATCH_IMAGES_CHUNK_SIZE;
  const batchCap = Math.max(1, Math.trunc(totalBatches ?? 0));

  const c = Math.min(Math.max(Math.trunc(currentBatch), 1), batchCap);

  const processedLow = Math.min(totalImages, (c - 1) * chunk);
  const processedHigh = Math.min(totalImages, c * chunk);

  const low = (processedLow / totalImages) * 100;
  const high = Math.min(100, (processedHigh / totalImages) * 100);

  return { low, high };
}
